import {MainLayout} from "../../components/layouts/MainLayout.tsx";
import {ChevronRightIcon} from "@heroicons/react/24/solid";
import {useChannelsService} from "../../hooks/useChannelsService.tsx";
import {useEffect, useState} from "react";
import apiNet from "../../newApi/apiNet.ts";
import {IFavorite} from "../../interfaces/account/favorite/IFavorite.ts";
import {useModal} from "../../hooks/useModal.tsx";
import AccountFavoriteDetailsModalContent
    from "../../components/account/favorite/modals/AccountFavoriteDetailsModal.tsx";
import {Simulate} from "react-dom/test-utils";

type TabItem = {
    label: string,
    isActive: boolean,
    searchType: string,
}

const initialTabs: TabItem[] = [
    {
        isActive: true,
        label: "Programy",
        searchType: "program"
    },
    {
        isActive: false,
        label: "Wyszukiwania",
        searchType: "search"
    }
]

const AccountFavoritesPage = () => {
    const {channels} = useChannelsService();
    const {showModal} = useModal();
    const [favorites, setFavorites] = useState<IFavorite[]>([]);
    const [loading, setLoading] = useState(true);
    const [tabs, setTabs] = useState(initialTabs);

    const modalHeader = (name: string) =>
        <div>
            <p className={"text-neutral-400 font-medium"}>Ulubione</p>
            {/*<h1 className={"text-2xl"}>{name}</h1>*/}
            <h1 className={"text-2xl"}>{name}</h1>
        </div>

    const handleOpenModal = (name: string) => {
        showModal(modalHeader(name), <AccountFavoriteDetailsModalContent channels={channels} name={name}/>);
    }

    function classNames(...classes: string[]) {
        return classes.filter(Boolean).join(' ')
    }

    const changeTab = (tab: TabItem) => {
        setTabs(prev =>
            prev.map(item => ({
                ...item,
                isActive: item.label === tab.label,
            }))
        );
    }

    useEffect(() => {
        // Pobierz dane po wejściu na widok
        const fetchFavorites = async () => {
            try {
                const res = await apiNet.getFavorites();
                const data = res.data;
                setFavorites(data);
            } catch (error) {
                console.error("Błąd podczas pobierania danych:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchFavorites();
    }, []);

    return (
        <>
            <MainLayout contentPadding={"px-0 pb-4 pt-14 md:pt-0"}>
                <div className={"bg-neutral-900 pt-4"}>
                    <p className={"ml-4 text-neutral-400 text-md"}>Twoje konto</p>
                    <h1 className={"text-3xl ml-4"}>Ulubione</h1>
                    <div className={"w-full bg-neutral-800 h-0.5 my-5 mb-0"}></div>
                    {/*<div className={"flex gap-10"}>*/}
                        <nav aria-label="Tabs" className="-mb-px flex">

                            {tabs.map((tab) => (
                                <button
                                    className={classNames(
                                        tab.isActive
                                            ? 'border-[#008DD2] text-[#008DD2]'
                                            : 'border-transparent text-neutral-400 hover:border-white/20 hover:text-neutral-300',
                                        'w-1/2 md:w-48 border-b-2 px-1 py-4 text-center text-sm font-medium transition',
                                    )}                                    onClick={() => changeTab(tab)}>
                                    <p className={"px-2"}>{tab.label}</p>
                                </button>
                            ))}
                        </nav>
                    {/*</div>*/}
                </div>
                <div className={"w-full"}>
                    {favorites.filter(item => item.type === tabs.find(item => item.isActive)?.searchType).map((favorite: IFavorite) =>
                        <button key={favorite.id}
                                onClick={() => handleOpenModal("Świat według kiepskich")}
                                className={"px-4 border-b border-neutral-700 py-3 flex items-center justify-between hover:bg-neutral-900/40 cursor-pointer transition w-full"}>
                            <p>{favorite.name}</p>
                            <ChevronRightIcon className={"w-5 h-5 text-[#008DD2]"}/>
                        </button>
                    )}
                </div>
            </MainLayout>
            {/*<AccountFavoriteDetailsModal channels={channels} name={"sdnsdn"}/>*/}
        </>
    );
};

export default AccountFavoritesPage;